import script from "./CommunityForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunityForm.vue?vue&type=script&lang=ts&setup=true"

import "./CommunityForm.vue?vue&type=style&index=0&id=9fda76dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fda76dc"]])

export default __exports__